import React from 'react';
const Footer = () => {
  return (
    <footer
      style={{ color: 'white', fontSize: '1rem', backgroundColor: 'black' }}
    >
      Made with ❤️ by{' '}
      <a href='https://devsoc.club' style={{ color: '#ADD8E6' }}>
        DevSoc
      </a>
    </footer>
  );
};

export default Footer;
